import React from 'react';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalObserver } from '../modal-observer';
import { ResetPasswordModal } from './reset-password-modal';

export const ResetPassword = ({ name }) => (
  <ModalObserver name={name}>
    {(props) => (
      <ModalWrapper {...props}>
        <ResetPasswordModal {...props} />
      </ModalWrapper>
    )}
  </ModalObserver>
);
